import React from 'react'
import OfficeLocations from '../Components/analyst/OfficeLocations'
import { Helmet } from "react-helmet-async";

function GlobalPresence() {
    return (
        <div>
            <Helmet>
    <title>
        Global Presence | Office Locations & Global Support | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode's global presence, office locations, and worldwide support network. Connect with our teams wherever you need technology and Enterprise AI & ServiceNow Consulting support."
    />

    <meta
        name="keywords"
        content="Mobikode Global Presence, Mobikode Office Locations, Global IT Services, Global Technology Services, Worldwide IT Support, Enterprise AI & ServiceNow Consulting Services, Mobikode Offices, Global Technology Consulting"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/global-presence"
    />

    <meta
        property="og:title"
        content="Global Presence | Office Locations & Global Support | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode's global office locations and support network delivering technology and Enterprise AI & ServiceNow Consulting services across markets."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/global-presence"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/presence/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Global Presence | Office Locations & Global Support | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's global presence, office locations, and worldwide technology support network."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/presence/bg1.png"
    />
</Helmet>
            <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/presence/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>
                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] lg:max-w-[980px] mt-auto md:mt-0">
                        <p className="font-[500] font-graphik lg:text-[18px] text-[14px] lg:leading-[24px] leading-[20px] text-[#FFFFFF] pb-[8px]">GLOBAL PRESENCE</p>
                        <h6 className="text-[#FFFFFF] max-w-[1016px] w-full text-[24px] md:text-[58px] leading-[20px] md:leading-[34px] lg:leading-[61.6px] font-sora font-[600] tracking-wider text-left opacity-90 lg:opacity-100">
                            We provide support, when you need it, where you need it
                        </h6>
                    </div>
                </div>
            </section>
            <OfficeLocations />
        </div>
    )
}

export default GlobalPresence
